import sdk from '@service/auth-sdk'

export class PhanTichLayerDataSource {
  constructor(
    layer,
    { successCallback, getFilterParams } = {},
    pagination = {}
  ) {
    this.layer = layer
    this.rowCount = null
    this.successCallback = successCallback
    this.getFilterParams = getFilterParams
    this.pagination = pagination
  }
  getRows(params) {
    let perpage = params.endRow - params.startRow
    let page = this.pagination.page
    if (this.getFilterParams) {
      this.getFilterParams(params.filterModel)
    }
    let filter = {}

    if (
      this.layer.style &&
      this.layer.style.content_filter &&
      this.layer.style.content_filter.length > 0
    ) {
      filter = this.layer.style.content_filter
    } else if (
      this.layer.style &&
      this.layer.style.content &&
      this.layer.style.content.length > 0
    ) {
      let content = this.layer.style.content[0]
      filter = content.rules
    }
    sdk
      .request({
        url: `/datastore-details/${this.layer.datastore_detail_id}/features`,
        method: 'post',
        params: {
          page,
          itemsPerPage: perpage,
          paginate: true,
          showGeometry: true,
        },
        data: {
          sortModel: params.sortModel,
          filterModel: params.filterModel,
          filter,
        },
      })
      .then((res) => {
        let rowsThisPage = res.data.list
        this.rowCount = rowsThisPage.length
        params.successCallback(rowsThisPage, rowsThisPage.length)
        if (this.successCallback) {
          this.successCallback(res.data)
        }
      })
      .catch((e) => {
        console.error(e)
        params.failCallback()
      })
  }
}
